// Record type identifies an NPC; disposition describes its relationship to the party.
const DISPOSITIONS = ['enemy', 'neutral', 'ally'];
const LABELS = { enemy: 'Enemy', neutral: 'Neutral', ally: 'Ally' };
const COLORS = { enemy: '#ff4d4f', neutral: '#e0ad32', ally: '#36b97b' };
function dispositionOf(unit) {
  if (DISPOSITIONS.includes(unit?.disposition)) return unit.disposition;
  if (unit?.disposition === 'friendly') return 'ally';
  return unit?.enemyId || unit?.enemy || unit?.entityType === 'enemy' ? 'enemy' : 'ally';
}
const dispositionLabel = unit => LABELS[dispositionOf(unit)];
const dispositionColor = unit => COLORS[dispositionOf(unit)];
const areHostile = (a, b) => dispositionOf(a) !== 'neutral' && dispositionOf(b) !== 'neutral' && dispositionOf(a) !== dispositionOf(b);
const areAllied = (a, b) => dispositionOf(a) !== 'neutral' && dispositionOf(a) === dispositionOf(b);
module.exports = { DISPOSITIONS, LABELS, dispositionOf, dispositionLabel, dispositionColor, areHostile, areAllied };
